import { __rest } from 'tslib';
import { t } from '../../i18n.es.js';
import React from 'react';
import { styled, Tag } from '@teko/ui';

const StyledProductName = styled.div(({ maxLines = 3 }) => `
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${maxLines};
  font-size: 13px;
`);
const StyledTag = styled(Tag)(({ color }) => `
  margin-right: 0.2rem;
  background-color: ${color};
  padding: 1px 0.4rem;
  font-size: 13px;
  font-weight: 400;
  padding: 2px 8px;
  border-radius: 4px;
`);
const RemainingProduct = styled.div `
  color: #d9852b;
  font-size: 0.75rem;
  margin-top: 2px;
  margin-bottom: 8px;
  line-height: 1rem;
`;
const ProductName = (_a) => {
    var { name, status, needManageStock, totalAvailableByStocks, isFlashSelling = false, tag } = _a, props = __rest(_a, ["name", "status", "needManageStock", "totalAvailableByStocks", "isFlashSelling", "tag"]);
    const NameTag = StyledProductName.withComponent(tag ? tag : 'div');
    return (React.createElement(React.Fragment, null,
        React.createElement(NameTag, Object.assign({}, props, { maxLines: totalAvailableByStocks > 0 && totalAvailableByStocks < 5 ? 2 : 3 }),
            status && (React.createElement(StyledTag, Object.assign({}, Object.assign(Object.assign({}, status), { children: status.value, variant: 'primary' })))),
            name),
        !isFlashSelling &&
            needManageStock &&
            totalAvailableByStocks > 0 &&
            totalAvailableByStocks < 5 && (React.createElement(RemainingProduct, null, t('Chỉ còn {{totalAvailableByStocks}} sản phẩm', {
            totalAvailableByStocks,
        })))));
};

export { ProductName };
